export const LOAD_VENDORS = 'vendors/LOAD_VENDORS';
export const LOAD_VENDORS_SUCCESS = 'vendors/LOAD_VENDORS_SUCCESS';
export const LOAD_VENDORS_ERROR = 'vendors/LOAD_VENDORS_ERROR';
export const SAVE_VENDOR_REQUEST = 'vendors/SAVE_VENDOR_REQUEST';
export const DELETE_VENDOR_REQUEST = 'vendors/DELETE_VENDOR_REQUEST';
